import React, { useState } from 'react';

function GratitudeLog({ gratitudeItems, setGratitudeItems }) {
  const [item, setItem] = useState('');

  const handleAdd = () => {
    if (item.trim()) {
      setGratitudeItems([...gratitudeItems, item.trim()]);
      setItem('');
    }
  };

  return (
    <div className="card">
      <h2>Gratitude Log</h2>
      <input
        type="text"
        placeholder="I'm grateful for..."
        value={item}
        onChange={(e) => setItem(e.target.value)}
      />
      <button onClick={handleAdd}>Add</button>
      <ul className="entry-list">
        {gratitudeItems.map((g, i) => (
          <li key={i}>🌟 {g}</li>
        ))}
      </ul>
    </div>
  );
}

export default GratitudeLog;
